<template>
  <div>
    <!-- LIST VIEW -->
    <v-list-item
      three-line
      v-if="!gridView"
      dense
      style="background: rgba(0, 77, 64, 0.5); border: 2px dashed rgba(255, 255, 255, 0.7);"
    >
      <v-list-item-avatar tile height="70px" width="80px">
        <v-img
          :src="require('../../assets/ghost-image.png')"
          max-width="100px"
        />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="subtitle-1"> Image asset </v-list-item-title>
        <v-list-item-subtitle>
          {{ getLangName }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <div class="text-xs-right">
          <v-icon large @click="add()">add_circle_outline</v-icon>
        </div>
      </v-list-item-action>
    </v-list-item>

    <!-- GRID VIEW -->
    <v-card
      color="rgba(0, 77, 64, 0.5)"
      style="border: 2px dashed rgba(255, 255, 255, 0.7);"
      max-width="250"
      min-width="250"
      v-if="gridView"
    >
      <v-list-item>
        <v-list-item-avatar color="grey">
          <v-icon medium>image</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="subtitle-1">
            {{ mediaTypeDescription }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ getLangName }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-img
        :src="require('../../assets/ghost-image.png')"
        max-height="250"
        contain
        class="grey darken-4 black--text align-end"
      >
      </v-img>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-icon large @click="add()">add_circle_outline</v-icon>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Enums from '@/helpers/Enums'
export default {
  props: {
    gridView: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    langId: {
      type: Number,
      required: false,
      default: function() {
        return parseInt(
          this.$store.state.ProjectStore.projectConfig[
            this.$store.state.ProjectStore.projectConfig.length - 1
          ].mediaData.defaultLangId || 1
        )
      }
    }
  },
  methods: {
    add() {
      this.$emit('add', 'poi-image')
    }
  },
  data: function() {
    return {
      name: '',
      bannerImageUrl: './assets/default_file_icon.png',
      descriptionText: '',
      mediaTypeDescription: 'Image asset',
      mediaDetailsDescription: 'Lang 1',
      mediaFileDescription: '',
      showDialog: false,
      mediaData: ''
    }
  },
  computed: {
    getLangName() {
      return Enums.lang[this.langId].name
    }
  }
}
</script>

<style scoped>
.text-xs-right {
  white-space: nowrap;
}
.ghost-wrapper {
  background: transparent !important;
  border: 2px dashed rgba(255, 255, 255, 0.7);
  box-sizing: border-box;
  border-radius: 6px;
}
</style>
